/* ========================================================================
* DOM-based Routing
* Based on http://goo.gl/EUTi53 by Paul Irish
*
* Only fires on body classes that match. If a body class contains a dash,
* replace the dash with an underscore when adding it to the object below.
*
* .noConflict()
* The routing is enclosed within an anonymous function so that you can
* always reference jQuery with $, even when in .noConflict() mode.
* ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
      },
      finalize: function() {

        $('#slider').slick({
          infinite: true,
          slidesToShow: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3500,
          respondTo: 'slider'
        });

        $('#slider-mobile').slick({
          infinite: true,
          slidesToShow: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3500,
          respondTo: 'slider'
        });

        $('#ctalink1').on('click', function() {
          $('#cta1').slideToggle('slow');
        });
        $('#ctalink2').on('click', function() {
          $('#cta2').slideToggle('slow');
        });

        $('#interviewlink').on('click', function() {
          $('#interview').slideToggle('slow');
        });

        $('.page-slider').slippry({
          slippryWrapper: '<div class="sy-box page-slider" />', // wrapper to wrap everything, including pager
          adaptiveHeight: true,
          captions: false,
          transition: 'fade', // fade, horizontal, kenburns, false
          speed: 1200,
          pause: 4000,
        });

        $('.content-slider').slippry({
          slippryWrapper: '<div class="sy-box content-slider" />', // wrapper to wrap everything, including pager
          adaptiveHeight: true,
          captions: false,
          transition: 'fade', // fade, horizontal, kenburns, false
          speed: 1200,
          pause: 3000,
        });

/*
        $('.photo-carousel .magnific-link').magnificPopup({type:'image', gallery:{
          enabled:true
        }});
*/

        $('.photo-carousel .magnific-link').magnificPopup({type:'image', gallery:{
          enabled:true
        }});

        $(".photo-carousel").owlCarousel({
          center: false,
          items: 6,
          margin: 5,
          autoWidth:true,
          loop: true,
          nav: false,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true,
          navText : ["<i class='fa fa-chevron-right photo-next'></i>","<i class='fa fa-chevron-left photo-prev'></i>"],
          responsive : {
            0 : {
              items : 1
            },
            480 : {
              items: 4
            },
            768 : {
              items: 6
            }
          }
        });

        $('div.photo-carousel figure').mouseenter(function() {
          $(this).find( "figcaption" ).css('display', 'block');
        });
        $('div.photo-carousel figure').mouseleave(function() {
          $(this).find( "figcaption" ).css('display', 'none');
        });

        $(".reviews-carousel").owlCarousel({
          center: false,
          items: 1,
          loop: true,
          nav: false,
          autoplay: true,
          autoplayTimeout: 3000,
          autoplayHoverPause: true
        });

        $('a[href*="#"]')
        // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
          // On-page links
          if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
            // Figure out element to scroll to
            var target = $(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
            // Does a scroll target exist?
            if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              jQuery('html, body').animate({
                scrollTop: target.offset().top
              }, 1000, function() {
                // Callback after animation
                // Must change focus!
                var $target = jQuery(target);
                $target.focus();
                if ($target.is(":focus")) { // Checking if the target was focused
                  return false;
                } else {
                  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              });
            }
          }
        });


      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {



      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
